import React, { FC } from 'react'
import { Box, Chip, Typography, makeStyles } from '@material-ui/core'
import { ItemPeriodFilter } from '../shared/periodStatus'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  label: {
    marginRight: theme.spacing(0.5),
    color: theme.palette.text.secondary,
  },
}))

interface PeriodFilterChipsProps {
  value: ItemPeriodFilter
  options: { value: ItemPeriodFilter; label: string }[]
  counts: Record<ItemPeriodFilter, number>
  onChange: (value: ItemPeriodFilter) => void
}

export const PeriodFilterChips: FC<PeriodFilterChipsProps> = ({ value, options, counts, onChange }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Typography variant="body2" className={classes.label}>
        表示対象:
      </Typography>
      {options.map(option => (
        <Chip
          key={option.value}
          label={`${option.label} (${counts[option.value]})`}
          color={value === option.value ? 'primary' : 'default'}
          clickable
          onClick={() => onChange(option.value)}
        />
      ))}
    </Box>
  )
}
